import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ token, children }) => {
  const [theToken, setTheToken] = useState("")
  const [loading, setLoading] = useState(true)

  useEffect(()=>{
    const tokeen = window.localStorage.getItem('idToken')
    setTheToken(tokeen);
    setLoading(false);
  }, [])


  if (loading) return null;

  if (theToken === null || theToken === "") {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default ProtectedRoute;
